import { useSelector } from "react-redux";
import {
    DesovaActions,
    INITIAL as DesovaState
} from "./desova";

export const useDesova = () => {
    // @ts-ignore
    const state = useSelector(state => state.desovaReducer);
    return {
        actions: {
            ...DesovaActions
        },
        state
    };
};